import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { Repository } from '@clavisco/core';
import { ISession } from '../interfaces/i-session';
import { StorageKeys } from '../enums/storage-keys';

@Injectable()
export class HeadersInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    let sessionInfo = Repository.Behavior.GetStorageObject<ISession>(StorageKeys.SESSION);

    if(sessionInfo)
    {
      request = request.clone({
        headers: request.headers.append("Authorization", `Bearer ${sessionInfo.access_token}`)
      });
    }

    return next.handle(request);
  }
}
